import { Children } from 'react';
import { VfModal } from '@vfit/shared/components';
import { LinkWithIcon } from '@vfit/shared/atoms';
import {
  Container,
  Description,
  Subtitle,
  Title,
  CheckboxDescription,
  ListContainer,
  ListElement,
  Checkbox,
} from './consents.style';
import { IConsentsProps } from './consents.models';
import ConsentsDetail from './components/ConsentsDetails/consentsDetail';
import { useConsentsHook } from './consents.hook';

const Consents = ({
  partyPrivacyItems,
  title,
  description,
  onUpdateConsents,
  terms,
}: IConsentsProps) => {
  const { modalConfig, handleOpenModal, handleCloseModal, handleChangeConsent } = useConsentsHook(
    partyPrivacyItems,
    onUpdateConsents
  );

  return (
    <Container>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Subtitle>{terms.title}</Subtitle>
      <ListContainer>
        {Children.toArray(
          partyPrivacyItems.map((consent) => (
            <div>
              <Checkbox onClick={(event) => event.stopPropagation()}>
                <div className="custom-checkbox" data-testid="consent-checkbox">
                  <input
                    type="checkbox"
                    defaultChecked={consent.selectedValue}
                    data-testid={consent.name}
                    onClick={() => handleChangeConsent(consent)}
                    id={consent.name}
                    onChange={() => {
                      return;
                    }}
                  />
                  <span className="checkmark" />
                </div>
              </Checkbox>
              <ListElement>
                <LinkWithIcon
                  onClick={() => handleOpenModal(consent)}
                  text={consent.name}
                  size="2"
                  textAlign="start"
                />
                <CheckboxDescription>{consent.description}</CheckboxDescription>
              </ListElement>
            </div>
          ))
        )}
      </ListContainer>

      <VfModal isOpen={modalConfig.isOpen} handleClose={handleCloseModal}>
        <ConsentsDetail consent={modalConfig.consent} />
      </VfModal>
    </Container>
  );
};

export default Consents;

